module.exports = __webpack_public_path__ + "static/media/03.7ad8e706.jpg";